import { AnyAction } from 'redux';
import * as actionTypes from '../actions/place';

const initialState = {
  current: {
    loaded: false,
    error: undefined,
    data: undefined,
  },
  subtitles: {
    loaded: false,
    error: undefined,
    data: [],
  },
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    /*  GET PLACE PART  */
    case `${actionTypes.PLACE_GET}:reset`: {
      return {
        ...state,
        current: {
          ...initialState.current,
        },
      };
    }
    case `${actionTypes.PLACE_GET}:loading`: {
      return {
        ...state,
        current: {
          ...state.current,
          loaded: false,
          error: undefined,
        },
      };
    }
    case `${actionTypes.PLACE_GET}:error`: {
      return {
        ...state,
        current: {
          ...state.current,
          loaded: true,
          error: action.payload,
        },
      };
    }
    case `${actionTypes.PLACE_GET}:success`: {
      return {
        ...state,
        current: {
          ...state.current,
          data: action.payload,
          loaded: true,
          error: undefined,
        },
      };
    }
    /*  GET PLACE SUBTITLES PART  */
    case `${actionTypes.PLACE_SUBTITLES_GET}:reset`: {
      return {
        ...state,
        subtitles: {
          ...initialState.subtitles,
        },
      };
    }
    case `${actionTypes.PLACE_SUBTITLES_GET}:loading`: {
      return {
        ...state,
        subtitles: {
          ...state.subtitles,
          loaded: false,
          error: undefined,
        },
      };
    }
    case `${actionTypes.PLACE_SUBTITLES_GET}:error`: {
      return {
        ...state,
        subtitles: {
          ...state.subtitles,
          loaded: true,
          error: action.payload.message,
        },
      };
    }
    case `${actionTypes.PLACE_SUBTITLES_GET}:success`: {
      return {
        ...state,
        subtitles: {
          ...state.subtitles,
          data: action.payload.data.fragments,
          loaded: true,
          error: undefined,
        },
      };
    }
    /*  PLACE TOGGLE FAVORITE PART   */
    case `${actionTypes.PLACE_TOGGLE_FAVORITE}:success`: {
      const data = state.current.data
        ? {
            ...(state.current.data || {}),
            liked: action.payload.data?.status === 'liked',
          }
        : undefined;

      return {
        ...state,
        current: {
          ...state.current,
          data,
          loaded: true,
          error: undefined,
        },
      };
    }
    default:
      return state;
  }
};
